export type BrowserFieldRegistration =
  | Readonly<{ state: 'unsupported' }>
  | Readonly<{ state: 'registered'; scope: string }>
  | Readonly<{ state: 'error'; message: string }>;

/** Registers the static-shell worker. Registration never grants offline access. */
export async function registerBrowserFieldShell(): Promise<BrowserFieldRegistration> {
  const serviceWorker = navigator.serviceWorker;
  if (!serviceWorker) {
    return { state: 'unsupported' };
  }

  try {
    const registration = await serviceWorker.register('/service-worker.js', {
      scope: '/',
      updateViaCache: 'none',
    });
    return { state: 'registered', scope: registration.scope };
  } catch (error) {
    return {
      state: 'error',
      message:
        error instanceof Error ? error.message : 'Service-worker registration failed',
    };
  }
}
